export default "__VITE_ASSET__C9d3HqwE__"